
export enum PageName {
    ORDERS = "orders",
    PREPARATION = "preparation",
    ALERT = "alert",
    HISTORY = "history",
    STORE = "store",
    STORES = "stores",
    PRODUCTS = "products",
    USERS = "users",
    CLOSURES = "closures",
    COLLECTION_SLOTS = "collection-slots",
    DROP_OFFS = "drop-offs",
    MASS_IMPORT = "mass-import",
    SMART_COLLAB_ERROR = "smart-collab-error",
}